export enum InvoiceType {

  // Rechnung mit ausgewiesener MwSt.
  VAT_DECLARE = 'VAT_DECLARE',
  // Netto Rechnung ohne ausgewiesener MwSt.
  NET_WITHOUT_VAT = 'NET_WITHOUT_VAT',
  // Brutto Rechnung ohne ausgewiesener MwSt.
  GROSS_WITHOUT_VAT = 'GROSS_WITHOUT_VAT',
}
